import { connect } from 'react-redux';
import { setLoading } from '../actions';
import { Payment, RedirectInstructions } from '../models';
import Page, { PageProps } from './Page';

interface PropsMappedFromState {
    isLoading: boolean;
    redirectInstructions: RedirectInstructions;
    payment: Payment;
    isAppRebrandActive: boolean;
}

export const _mapStateToProps = ({
    isLoading,
    redirectInstructions,
    payment,
    isAppRebrandActive,
}: {
    isLoading: boolean;
    redirectInstructions: RedirectInstructions;
    payment: Payment;
    isAppRebrandActive: boolean;
}): PropsMappedFromState => ({
    isLoading,
    redirectInstructions,
    payment,
    isAppRebrandActive,
});

interface PropsMappedFromDispatch {
    setLoading: PageProps['setLoading'];
}

export const _mapPropsToDispatch: PropsMappedFromDispatch = {
    setLoading,
};

export type ConnectedPageProps = Omit<
    PageProps,
    keyof PropsMappedFromState | keyof PropsMappedFromDispatch
>;

export default connect(_mapStateToProps, _mapPropsToDispatch)(Page);
